import VueRouter from "vue-router";
import oneUtils from "../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import configUtils from '@/store/configUtils';
import store from '@/store';
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import qs from "qs";




const manageLinkLoginResponse = (to, next, newQuery, registerFirst, initialLoginRequest)=>{
    oneUtils.utils.hideLeftLoader();
    if (initialLoginRequest.authorization) {
      to.meta["authorization"] = initialLoginRequest.authorization;
      store.dispatch("login");
      if (registerFirst=="true"){
        oneUtils.sessionUtils.forceLogout(store.getters.configure("key_for_internal_client_id"),next({
          path: "/register",
          query: newQuery,
        }));
      }else{
        next();
      }
    }else{
      manageLinkErrors(next,registerFirst, newQuery)
    }
}

const startPageWithEpaas = (to,next)=>{
  if(to.query.epaas_consenttoken){
    const epaas = window['epaas'];
    const initObj ={
      tenant: store.getters.configure('_tenant_id'),
      locale: store.getters.configure('_tenant_locale')
    }
    initObj['consentToken']=to.query.epaas_consenttoken;
    ((window['epaas'] && window['epaas'].api) || window).addEventListener('consentcontroller.api.initialized', ()=>{
      epaasInitialized = true;
      next();
    });
    epaas.api.initialize(initObj)
  }else{
    epaasInitialized = true;
    next();
  }
}

const getUserInfo = (to, next)=>{
  store.dispatch("login");
  oneUtils.httpClient
  .getUserInfo()
    .then((res) => {
      if (res) {
        next();
      } else {
        to.meta["customerError"] = oneUtils.enums.errorReasons.SYSTEM_ERROR;
        next();
      }
    })
    .catch(() => {
      to.meta["customerError"] = oneUtils.enums.errorReasons.SYSTEM_ERROR;
      next();
    });
}

const manageLinkErrors = (next, registerFirst, newQuery)=>{
  oneUtils.utils.hideLeftLoader();
  if (registerFirst=="true"){
    oneUtils.sessionUtils.forceLogout(store.getters.configure("key_for_internal_client_id"),next({
      path: "/register",
      query: newQuery,
    }));
  }else{
    next({
      path: "/login",
      query: newQuery,
    });
  }
}

const  manageLinkLogin = async (to, next, newQuery, registerFirst)=>{
  if (process.env.NODE_ENV !== "development") {

  
    


    const {initialLoginRequest} = await oneUtils.loginUtils.configureLoginRequest({
      initializedBy: oneUtils.enums.loginInitializers.LINK_PAGE, 
      store:store, 
      $cookies: null
    })  
    oneUtils.loginUtils.doAuthorizationFirstStep(false).then(() => {
      let accessToken = window.localStorage.getItem("oneid_access_token");
      if (accessToken) {
        manageLinkLoginResponse(to, next, newQuery, registerFirst, initialLoginRequest);
      }else{
        oneUtils.loginUtils.retrieveNewAccessToken('link').then(()=>{
          manageLinkLoginResponse(to, next, newQuery, registerFirst, initialLoginRequest)
        }).catch((route)=>{
          to.meta["customerError"] = oneUtils.enums.errorReasons.SYSTEM_ERROR;
          next(route)
        });
      }
    }).catch(()=>{
      manageLinkErrors(next,registerFirst, newQuery)
    });
  }else{
    next();
  }
}



const manageProfileLogin = (to, next)=>{

  if (process.env.NODE_ENV !== "development") {
    let accessToken;
    if(to.query.originalUrl) { //coming from webcomponent
      to.meta["wc_redirection"] = to.query.originalUrl;

      accessToken = to.query.accessToken;
      window.localStorage.setItem("oneid_access_token", accessToken);
    }  else if (to.query.isFromApp) { //coming from app
      to.meta["app_redirection"] = to.query.isFromApp;

      accessToken = to.query.accessToken;
      window.localStorage.setItem("oneid_access_token", accessToken);
    } else {      
      oneUtils.loginUtils.stateCheck(to.query.state);
      //check access_token
      accessToken = window.localStorage.getItem("oneid_access_token");
    }
    oneUtils.loginUtils.configureLoginRequest({
      initializedBy: oneUtils.enums.loginInitializers.PROFILE_PAGE, 
      store:store, 
      $cookies: null
    });
    
    if (!accessToken) {
      oneUtils.loginUtils.retrieveNewAccessToken('profile').then(()=>{
        getUserInfo(to, next);
      }).catch((route)=>{
        to.meta["customerError"] = oneUtils.enums.errorReasons.SYSTEM_ERROR;
        route ? next(route) : next();
      });
    }else{
      oneUtils.loginUtils.isTokenValid(accessToken).then((res) => {
        if(res){
          getUserInfo(to, next);
        }else{
          oneUtils.loginUtils.retrieveNewAccessToken('profile').then(()=>{
            getUserInfo(to, next);
          }).catch((route)=>{
            to.meta["customerError"] = oneUtils.enums.errorReasons.SYSTEM_ERROR;
            route ? next(route) : next();
          });
        }
      }).catch((err) => {
          to.meta["customerError"] = "error_generic";
          next();
      })
    }
  }else{
    getUserInfo(to, next);
  }
}

/**
 * This method manages the checkboxes for consents inside the link page
 * @param to
 */
const manageLinkParams = (to) => {
  const isInBrowser: boolean = to.query.is_browser || false;
  const isMobile = oneUtils.utils.isMobile();
  const isLinkPageConsentsEnabled: boolean = store.getters.configure("enable_link_page_consents");
  const showLinkPageConsents = isInBrowser && isMobile && isLinkPageConsentsEnabled;

  // if (showLinkPageConsents)
    window.sessionStorage.setItem("showLinkPageConsents", showLinkPageConsents.toString());
}

const routes = [
  {
    path: "/applogin",
    name: "applogin",
    component: () =>
      import(/* webpackChunkName: "registration" */ "../views/Applogin.vue"),
      beforeEnter(to, from, next) {
        next();
      },
  },
  {
    path: "/register",
    name: "register",
    component: () =>
      import(/* webpackChunkName: "registration" */ "../views/Registration.vue"),
    beforeEnter(to, from, next) {
      oneUtils.utils.storeParametersToLocalStorage(to.query);
      next();
    },
  },
  {
    path: "/preregister",
    name: "preregister",
    component: () =>
      import(/* webpackChunkName: "preregistration" */ "@/views/Preregistration.vue"),
      beforeEnter(to, from, next) {
        if(!to.query.email){
          const preRegistrationToken = to.query.preRegistrationToken || to.query.token;
          to.meta["resetPasswordToken"] = to.query.resetPasswordToken;
          if (to.query.resetPasswordToken) {
            next();
            return;
          }
          if(!preRegistrationToken){
            to.meta["customerError"] = "error_preregistration_token_not_provided";
            next();
            return;
          }
          oneUtils.httpClient
          .getEmailByPreRegToken(preRegistrationToken)
          .then((res: any) => {
            if(res && res.data && res.data.metaInfo && res.data.metaInfo.emailAddress){
              to.meta["email"] = res.data.metaInfo.emailAddress;
            }
            if(res?.data?.customer?.businessPartner) {
              to.meta["salutation"] = res.data.customer.businessPartner.salutation;
              to.meta["givenname"] = res.data.customer.businessPartner.givenName;
              to.meta["surname"] = res.data.customer.businessPartner.surname;
              to.meta["gcid"] = res.data.customer.businessPartner.gcid;
            }
            next();
          })
          .catch((err) => {
            oneUtils.utils.hideLeftLoader();
            if(
              err.errorCode==oneUtils.enums.errorReasons.RESOURCE_NOT_FOUND
            ){
              to.meta["preregistrationResourceNotFoundError"] = "true";
            }else{
              to.meta["customerError"] = "error_generic";
            }

            next();
          });
        }else{
          next();
        }
        oneUtils.utils.storeParametersToLocalStorage(to.query);
      },
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/Login.vue"),
    beforeEnter(to, from, next) {
      to.meta["successPreregistration"] = to.query.successPreregistration === "true";
      oneUtils.utils.storeParametersToLocalStorage(to.query);
      // if(to.query.user_code){
      //   next({
      //     path: "/link",
      //     query: to.query,
      //   });
      // }else{
      //   next();
      // }
      next();

    },
  },
  {
    path: "/resetpassword",
    name: "resetpassword",
    component: () =>
      import(
        /* webpackChunkName: "resetpassword" */ "@/views/ResetPassword.vue"
      ),
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: () =>
      import(
        /* webpackChunkName: "maintenance" */ "@/views/Maintenance.vue"
      ),
  },
  {
    path: "/link",
    name: "link",
    component: () =>
      import(
        /* webpackChunkName: "link" */ "@/views/Link.vue"
      ),
      beforeEnter(to, from, next) {
        const registerFirst = to.query['register_first'];
        const newQuery = to.query;
        newQuery["redirectFrom"] = to.name;
        if (!store.getters.configure("show_link_page")) {
          next({
            path: "/",
            query: to.query,
          });
        }else{
          try {
            manageLinkParams(to);
            if (process.env.NODE_ENV !== "development") {
              oneUtils.loginUtils.stateCheck(to.query.state);
            }
            manageLinkLogin(to, next, newQuery, registerFirst);
          } catch (e) {
            oneUtils.utils.storeParametersToLocalStorage(to.query);
            if (registerFirst=="true"){
              oneUtils.sessionUtils.forceLogout(store.getters.configure("key_for_internal_client_id"),next({
                path: "/register",
                query: newQuery,
              }));
            }else{
              next({
                path: "/login",
                query: newQuery,
              });
            }
            oneUtils.utils.hideLeftLoader();
          }
        }
      },
  },
  {
    path: "/changepassword",
    name: "changepassword",
    component: () =>
      import(
        /* webpackChunkName: "changepassword" */ "@/views/ChangePassword.vue"
      ),
  },
  {
    path: "/logout",
    name: "logout",
    component: () =>
      import(
        /* webpackChunkName: "logout" */ "@/views/Logout.vue"
      ),
  },
  {
    path: "/activate",
    name: "activate",
    component: () =>
      import(/* webpackChunkName: "activation" */ "@/views/Activation.vue"),
  },
  {
    path: "/config",
    name: "configurationStatus",
    component: () =>
      import(
        /* webpackChunkName: "configurationStatus" */ "@/views/ConfigurationStatus.vue"
      ),
      beforeEnter(to, from, next) {
        if(store.getters.configure("show_config_page")){
          next();
        }else{
          next({
            path: "/",
            query: to.query,
          });
        }
      }
  },
  {
    path: "/translations",
    name: "translations",
    component: () =>
      import(/* webpackChunkName: "translations" */ "@/views/translation.vue"),
      beforeEnter(to, from, next) {
        // parametro in config per mostrare o meno la pagina?
        //oneUtils.utils.showLeftLoader();
        // controlli su login ?

        next();
      }
  },
  {
    path: "/profile",
    name: "profile",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/Profile.vue"),
    beforeEnter(to, from, next) {
      if (!store.getters.configure("show_profile_page")) {
        next({
          path: "/",
          query: to.query,
        });
      } else {
        oneUtils.utils.showLeftLoader();
        try {

          manageProfileLogin(to, next);


        } catch (e) {
          oneUtils.utils.storeParametersToLocalStorage(to.query);
          const newQuery = to.query;
          newQuery["redirectFrom"] = to.name;
          next({
            path: "/login",
            query: newQuery,
          });
          oneUtils.utils.hideLeftLoader();
        }
      }
    },
  },
  {
    path: "/",
    redirect: "/register",
  },
];


let router : VueRouter.Router;
const el = document.getElementsByTagName('v-profile');
const isWC = !!el[0];
let epaasInitialized = false;
if(isWC){
  router = createRouter({
    history: createWebHistory(),
    routes: [],
  })
}else{

    router = createRouter({
      history: createWebHashHistory(),
      routes: routes,
      stringifyQuery: qs.stringify,
    })

  router.beforeEach((to, from, next) => {
    configUtils
      .setupConfigurations()
      .then(() => {

        const now = Math.floor((new Date().getTime())/1000);
        const start = store.getters.configure('_maintenance_start_date');
        const end = store.getters.configure('_maintenance_end_date');
        if(start<now && now<end && to.name!='maintenance'){
          next({
            path: "/maintenance",
          });
        }else{

          const areEpaasAndTracyEnabled = function(){
            const areEpaasAndTracyEnabledGlobal = store.getters.configure("enable_epaas_&_tracy_tracking_global");
            const areEpaasAndTracyEnabledClient = store.getters.configure("enable_epaas_&_tracy_tracking");
            if (areEpaasAndTracyEnabledGlobal && areEpaasAndTracyEnabledClient !== undefined) {
                return areEpaasAndTracyEnabledGlobal && areEpaasAndTracyEnabledClient;
            }
            return areEpaasAndTracyEnabledGlobal;
          }

          if(areEpaasAndTracyEnabled() && !epaasInitialized){
            startPageWithEpaas(to,next);
          }else{
            epaasInitialized = true;
            next();
          }
        }
      })
      .catch((e) => {
        console.log('setup configuration error: ',e);
      });
  });
}

export default router;
